import { Pipe, PipeTransform } from '@angular/core';

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
*/
@Pipe({
    name: 'currencySuffix',
    standalone: false
})
export class CurrencySuffixPipe implements PipeTransform {

    private units = [
        '',
        'K',
        'M',
    ];

    transform(value: number = 0, precision: number = 2): string {
        if (isNaN(parseFloat(String(value))) || !isFinite(value)) {
            return 'NaN';
        }

        let unit = 0;

        if (value >= 1000) {
            precision++;
        }

        while (value >= 1000) {
            value /= 1000;
            unit++;
        }

        return value.toFixed(+ precision) + ' ' + this.units[unit];
    }
}
